import axios from 'axios';
import mbpLogger from 'mbp-logger';
import mbpUtil from 'mbp-api-util';
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HTTP_HEADER_ACCEPTED_ENCODING = 'gzip, deflate';

/**
 * add jwtToken as a header
 * @param {*} jwt_token
 * @param {*} config
 */
var addJwtToken = function addJwtToken(jwtToken) {
  return "Bearer ".concat(jwtToken);
};
var getHost = function getHost() {
  var windowHostname = typeof window !== 'undefined' && window.location && window.location.hostname;
  if (!windowHostname) {
    return mbpUtil.getEnv('APP_FLAGS_HOST_SSR') || 'flagsapi.common-services.svc.cluster.local:8080';
  }
  var wcHost = mbpUtil.getEnv('APP_WC_HOST');
  return wcHost || windowHostname || 'localhost';
};
var getProtocol = function getProtocol() {
  // SSR
  if (typeof window === 'undefined') {
    return process.env.APP_WC_PROTOCOL_SSR || 'https';
  }
  return mbpUtil.getEnv('APP_WC_PROTOCOL') || 'https';
};
var getPrefix = function getPrefix() {
  // SSR
  if (typeof window === 'undefined') {
    return process.env.APP_API_PREFIX_SSR || '';
  }
  return mbpUtil.getEnv('APP_API_PREFIX') || '/r/api';
};
var setHeaders = function setHeaders(headersInput) {
  var headers = _objectSpread({}, headersInput);
  if (typeof window === 'undefined') {
    headers['Accept-Encoding'] = HTTP_HEADER_ACCEPTED_ENCODING;
  }
  return headers;
};

/**
 *
 * @param method    - get/post/put/delete/etc
 * @param url       - string for url to call
 * @param params    - object with parameters to be added to the url
 * @param data      - body
 * @param env       - environment properties
 * @param header    - object with headers to be added to the request
 * @param jwtToken  - accesstoken
 */
var callAxios = function callAxios(method, url, params, data, env, headers, jwtToken) {
  try {
    var config = {
      method: method,
      url: url,
      params: _objectSpread({}, params),
      headers: setHeaders(headers),
      data: data
    };
    config.headers = _objectSpread({}, config.headers);
    if (jwtToken) ;
    return axios(config);
  } catch (ex) {
    mbpLogger.logError({
      method: method,
      url: url,
      params: params,
      data: data,
      env: env,
      headers: headers,
      "function": 'callAxios',
      module: 'feature-flag-sdk',
      jsError: ex,
      message: 'callAxios FAILED'
    });
  }
  return null;
};

/**
 * @param {*} wcEnv
 * @param {*} appName
 * @param {*} resourcePath
 */
var getUrl = function getUrl(wcEnv, appName, resourcePath) {
  mbpLogger.logDebug({
    env: wcEnv,
    "function": 'getUrl',
    module: 'feature-flag-sdk',
    message: 'getUrl variables'
  });
  var apiHost = wcEnv.host || getHost();
  var apiHostUrl = "".concat(wcEnv.protocol || getProtocol(), "://").concat(apiHost);
  var uri = "".concat(wcEnv.prefix || getPrefix());
  var url = "".concat(apiHostUrl).concat(uri, "/feature/").concat(appName, "/").concat(resourcePath);
  mbpLogger.logDebug({
    url: url,
    uri: uri,
    "function": 'getUrl',
    module: 'feature-flag-sdk',
    message: 'getUrl variables'
  });
  return url;
};

/**
 * GET Feature Flags
 * @param {*} env
 * @param {*} appName
 * @param {*} body
 */

var getFeatureFlags = function getFeatureFlags(env, appName, body) {
  try {
    var url = getUrl(env, appName, 'flags');
    return callAxios('post', url, null, body, env);
  } catch (ex) {
    mbpLogger.logError({
      env: env,
      "function": 'getFeatureFlags',
      module: 'feature-flag-sdk',
      jsError: ex,
      message: 'feature flags server SDK getFeatureFlags failed'
    });
  }
  return null;
};

/**
 * GET Specific Feature Flags status
 * @param {*} env
 * @param {*} params
 * @param {*} body
 * @param {*} flagName
 * @param {*} defaultValue
 * @param {*} returnType
 */
var getFlagVariation = function getFlagVariation(env, appName, body, flagName) {
  var defaultValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var returnType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'boolean';
  try {
    if (flagName) {
      var resourcePath = "variation/".concat(returnType);
      var params = {
        flagName: flagName,
        defaultValue: defaultValue
      };
      var url = getUrl(env, appName, resourcePath);
      return callAxios('post', url, params, body, env);
    }
    mbpLogger.logError({
      env: env,
      "function": 'getFlagVariation',
      module: 'feature-flag-sdk',
      message: 'Missing flagName to get flag status'
    });
  } catch (ex) {
    mbpLogger.logError({
      env: env,
      "function": 'getFlagVariation',
      module: 'feature-flag-sdk',
      jsError: ex,
      message: 'feature flags server SDK getFlagVariation failed'
    });
  }
  return null;
};

/**
 * @class WC API Core
 */
var FeatureFlags = {
  getFeatureFlags: getFeatureFlags,
  getFlagVariation: getFlagVariation
};
export { FeatureFlags as default };